// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"n3-z"};